import './SideBar.css'

import Hobbies from './Hobbies';
import Language from './Language';
import PersonalInfo from './PersonalInfo';
const SideBar = () =>{
	return(
		<>
			<h1 className="contentHeading">ABOUT ME</h1>
			<p className="aboutContent text-center pt-3">
				Innovative task-driven professional with 6+ years of experience in Web Designing & 
				Development across diverse industries. Equipped with a record of success in consistently 
				identifying and providing the technological needs of companies through ingenious innovation. 
				Proficient in developing database, creating user Interfaces, writing and testing codes,
				troubleshooting complex/simple issues, and Implementing new Features based on User Feedback.
			</p>
			<h1 className="contentHeading">CONTACT INFO</h1>
			<PersonalInfo />
			<h1 className="contentHeading">LANGUAGES</h1>
			<Language />
			<h1 className="contentHeading">HOBBIES</h1>
			<Hobbies />
		</>
		)
}


export default SideBar;